import { Search, X } from "lucide-react";
import { TextInput } from "./TextInput";

export function SearchField({
  value,
  onChange,
  label,
  placeholder = "Search",
  className = "flex-1",
}: {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  className?: string;
}) {
  return (
    <div className={`relative ${className}`}>
      <Search
        strokeWidth={2.5}
        aria-hidden="true"
        className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-foreground/70"
      />

      <TextInput
        type="search"
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-9 pr-10"
      />

      {value && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={() => onChange("")}
          className="absolute right-1 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded text-foreground/70 hover:bg-muted hover:text-foreground"
        >
          <X className="h-3 w-3" strokeWidth={3} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
